export default class GateAccessDenied extends Error {
    constructor(message) {
        super(message);

        this.name = 'GateAccessDenied';
    }
}
